import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1fae31e3"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "actions"
};
import DLayout from '@/components/DLayout.vue';
import DProgressBar from '@/components/DProgressBar.vue';
import DButton from '@/components/DButton.vue';
import { computed } from 'vue';
import { useComponent } from '@/hooks/useComponent';
import { useAction } from '@/hooks/useAction';
import { useFetchSurvey } from '@/hooks/useFetchSurvey';
import ConfigProvider from '@/components/ConfigProvider.vue';
import { useStore } from '@/stores/main';
import { t } from '@/lang';
import { watch } from 'vue';
import { ref } from 'vue';
import DWelcome from './DWelcome.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DHome',
  setup: function setup(__props) {
    var _useComponent = useComponent(),
      is = _useComponent.is;
    var _useStore = useStore(),
      showList = _useStore.showList;
    var _useFetchSurvey = useFetchSurvey(),
      surveyInfo = _useFetchSurvey.surveyInfo,
      survey_conf_id = _useFetchSurvey.survey_conf_id,
      survey = _useFetchSurvey.survey,
      loading = _useFetchSurvey.loading;
    var _useAction = useAction(surveyInfo, survey_conf_id),
      currentIndex = _useAction.currentIndex,
      next = _useAction.next,
      questionRef = _useAction.questionRef,
      prev = _useAction.prev;
    var glowing = ref(false);
    var timer = ref(null);
    var currentQuestion = computed(function () {
      var _surveyInfo$value;
      return (_surveyInfo$value = surveyInfo.value) === null || _surveyInfo$value === void 0 ? void 0 : _surveyInfo$value[currentIndex.value];
    });
    var minVal = computed(function () {
      var _survey$value$min_val, _survey$value;
      return (_survey$value$min_val = (_survey$value = survey.value) === null || _survey$value === void 0 ? void 0 : _survey$value.min_val) !== null && _survey$value$min_val !== void 0 ? _survey$value$min_val : undefined;
    });
    var maxVal = computed(function () {
      var _survey$value$max_val, _survey$value2;
      return (_survey$value$max_val = (_survey$value2 = survey.value) === null || _survey$value2 === void 0 ? void 0 : _survey$value2.max_val) !== null && _survey$value$max_val !== void 0 ? _survey$value$max_val : undefined;
    });
    var startGlowing = function startGlowing() {
      if (timer.value) clearTimeout(timer.value);
      glowing.value = false;
      timer.value = setTimeout(function () {
        glowing.value = true;
      }, 10000);
    };
    startGlowing();
    var nextQuestion = function nextQuestion() {
      startGlowing();
      next(survey_conf_id.value);
    };
    var progress = computed(function () {
      var _surveyInfo$value2;
      if (loading.value) return 0;
      return currentIndex.value / ((_surveyInfo$value2 = surveyInfo.value) === null || _surveyInfo$value2 === void 0 ? void 0 : _surveyInfo$value2.length) * 100;
    });
    watch(function () {
      return surveyInfo;
    }, function () {
      showList.value = [];
      surveyInfo.value.forEach(function (question) {
        var _question$content$gro, _question$content;
        var group = (_question$content$gro = (_question$content = question.content) === null || _question$content === void 0 ? void 0 : _question$content.group) !== null && _question$content$gro !== void 0 ? _question$content$gro : [];
        group.forEach(function (item) {
          var right = item.right;
          if (right === 'show') {
            showList.value.push(item.to);
          }
        });
      });
    }, {
      immediate: true,
      deep: true
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(DLayout, null, {
        header: _withCtx(function () {
          return [_createVNode(DProgressBar, {
            progress: progress.value
          }, null, 8, ["progress"])];
        }),
        body: _withCtx(function () {
          var _currentQuestion$valu;
          return [(_currentQuestion$valu = currentQuestion.value) !== null && _currentQuestion$valu !== void 0 && _currentQuestion$valu.question_type ? (_openBlock(), _createBlock(ConfigProvider, {
            key: 0,
            question: currentQuestion.value
          }, {
            "default": _withCtx(function () {
              return [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(is)(currentQuestion.value.question_type)), {
                key: currentQuestion.value.question_id,
                ref_key: "questionRef",
                ref: questionRef
              }))];
            }),
            _: 1
          }, 8, ["question"])) : _createCommentVNode("", true)];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_unref(currentIndex) > 0 ? (_openBlock(), _createBlock(DButton, {
            key: 0,
            onClick: _withModifiers(_unref(prev), ["stop"])
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(t)().A12()), 1)];
            }),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_unref(questionRef) ? (_openBlock(), _createBlock(DButton, {
            key: 0,
            active: glowing.value,
            onClick: _withModifiers(nextQuestion, ["stop"])
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(t)().A13()), 1)];
            }),
            _: 1
          }, 8, ["active"])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      }), _createVNode(DWelcome, {
        min: minVal.value,
        max: maxVal.value
      }, null, 8, ["min", "max"])], 64);
    };
  }
});